import {IPhase} from 'types/project';

export default (phases: IPhase[]) => {
  const copy = [...phases];
  return copy.sort(({order: a}, {order: b}) => a - b);
};
